import { observer } from 'mobx-react-lite'
import type { VirtualListItemFunctionComponent } from './VirtualList'
import styles from './VirtualList.module.scss'
import type { VirtualListRowData } from './VirtualListStore'

export const VirtualListItemComponent = observer(
  function VirtualListItemComponent<T>({
    row,
    renderItem: RenderItem,
  }: {
    row: VirtualListRowData<T>
    renderItem: VirtualListItemFunctionComponent<T>
  }) {
    return (
      <div className={styles.item} style={row.style}>
        {row.item && <RenderItem item={row.item} />}
      </div>
    )
  },
)
